import { useTranslation } from 'react-i18next';
import { CardPocket } from '@/common/components/CardPocket/CardPocket';
import { Icon } from '@/common/components/Icons/Icon';
import { ROUTES } from '@/common/constants/routes';
import { useBudgetsSummary } from '@/common/integrations/menhir/employee/budgets/budgets.hooks';
import { MoneyUtils } from '@coverflex-tech/hypernova-utils';
import { useRouter } from 'expo-router';
import { useGetBudgetsCardLabel } from './PTBudgetsCardPocket.utils';

export function PTBudgetsCardPocket() {
  const { t } = useTranslation();
  const router = useRouter();

  const {
    availableBalance,
    numberOfActiveBudgets,
    loading: loadingBudgets,
  } = useBudgetsSummary();

  const label = useGetBudgetsCardLabel(numberOfActiveBudgets);

  return (
    <CardPocket
      title={t('wallet.pockets.budgets')}
      icon={<Icon icon="star" />}
      values={[
        {
          label,
          value: MoneyUtils.moneyToString(availableBalance),
          loading: loadingBudgets,
        },
      ]}
      onPress={() => router.navigate(ROUTES.BUDGETS)}
    />
  );
}
